import calgary from './cities/calgary'
import edmonton from './cities/edmonton'
// import reddeer from './cities/reddeer'

export default {
  province: 'Alberta',
  abbr: 'A.B.',
  alpha: 'AB',
  lawSociety: 'Law Society of Alberta',
  writeup: '',
  cities: [calgary, edmonton]
}



// WEBPACK FOOTER //
// ./src/store/provinces/alberta/index.js